/**************************************************
 * Nombre:       Formulario_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    EditAttributesOutlined,
    Flag,
    FormatListBulletedAdd,
    PhoneAndroidOutlined,
    TitleOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";

const Formulario_Anuncios = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={64} ancho={58} {...props}  />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen de 640px por 580px de menos de 300K de peso, fondo
                        transparente</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo del Anuncio'}
                                  dato={'titulo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Sub Titulo'}
                                  dato={'subtitulo'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcin del Anuncio'}
                                  dato={'descripcion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={EditAttributesOutlined} nombre={'Texto Bonton'} dato={'textoBoton'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectFalsoVerdadero Icono={FormatListBulletedAdd} nombre={'va a formulario?'}
                                                 dato={'formulario'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Link Bonton'} dato={'link'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Anuncios